import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';
import { Link as MuiLink } from '~/UIKit';
import { useStyles } from './AcceptRejectStyles';

interface CountDownProps {
  redirectUrl?: string;
}

export const AcceptRejectCountDown = ({ redirectUrl }: CountDownProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const COUNTER_DURATION = 5;

  const [seconds, setSeconds] = useState<number>(COUNTER_DURATION);

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 950);
    } else {
      setSeconds(0);
    }
  }, [seconds]);

  return (
    <div>
      {seconds > 0 ? (
        <Typography className={classes.text}>
          <Trans
            i18nKey="publicApi.acceptReject.redirecting"
            values={{
              counter: seconds,
            }}
            components={{
              break: <br />,
            }}
          />
        </Typography>
      ) : (
        <Typography className={classes.text}>
          {t('publicApi.redirect.click')}
          <MuiLink key="terms" href={redirectUrl} rel="noopener noreferrer">
            {t('app.here')}
          </MuiLink>
        </Typography>
      )}
    </div>
  );
};
